// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=========================================================================================
	File Name: customizer.scss
	Description: CSS used for demo purpose only. Remove this css from your project.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy React admin Template
	Version: 1.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
  ==========================================================================================*/
.customizer {
  width: 400px;
  right: -400px;
  padding: 0;
  background-color: #fff;
  z-index: 1051;
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100vh;
  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  backface-visibility: hidden;
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
.customizer .open-icon {
  animation: Spin 2s infinite linear;
  position: relative;
  top: -2px;
}
.customizer.open {
  right: 0;
}
.customizer .customizer-content {
  position: relative;
  height: calc(100% - 7rem);
}
.customizer .customizer-content .bg-default {
  background-color: #fff;
}
.customizer .customizer-close {
  position: absolute;
  right: 30px;
  top: 20px;
  padding: 7px;
  width: auto;
  z-index: 10;
  color: #626262;
}
.customizer .customizer-close i {
  font-size: 1.71rem;
}
.customizer .customizer-toggle {
  background: #7367f0;
  color: #fff;
  display: block;
  box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.1);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 50%;
  width: 38px;
  height: 38px;
  left: -39px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.customizer .color-box {
  height: 35px;
  width: 35px;
  margin: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
}
.customizer .color-box.selected {
  box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);
  transition: all 0.2s ease-in-out;
}
.customizer .color-box.disabled {
  pointer-events: none;
  cursor: not-allowed;
}

body.dark-layout .hide-scroll-top-switch .custom-switch .custom-control-label:before,
body.dark-layout .collapse-sidebar .custom-switch .custom-control-label:before {
  background-color: #10163a;
}

.buy-now {
  position: fixed;
  bottom: 5%;
  right: 79px;
  z-index: 1031;
}
.buy-now .btn {
  box-shadow: 0 1px 20px 1px #EA5455 !important;
}
.buy-now .btn:hover {
  box-shadow: none !important;
}

@keyframes Spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/components/customizer.scss"],"names":[],"mappings":"AAAA;;;;;;;;6FAAA;AAUA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,0DAAA;EACA,2BAAA;EACA,0CAAA;EACA,+EAAA;AAAF;AAGE;EACE,kCAAA;EACA,kBAAA;EACA,SAAA;AADJ;AAIE;EACE,QAAA;AAFJ;AAME;EACE,kBAAA;EACA,yBAAA;AAJJ;AAMI;EACE,sBAAA;AAJN;AASE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AAPJ;AAQI;EACE,kBAAA;AANN;AAWE;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,2CAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AATJ;AAaE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAXJ;AAYI;EACE,6CAAA;EACA,gCAAA;AAVN;AAYI;EACE,oBAAA;EACA,mBAAA;AAVN;;AAoBQ;;EACE,yBAAA;AAhBV;;AAuBA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AApBF;AAqBE;EACE,6CAAA;AAnBJ;AAoBI;EACE,2BAAA;AAlBN;;AAyBA;EACE;IACE,oBAAA;EAtBF;EAwBA;IACE,yBAAA;EAtBF;AACF","sourcesContent":["/*=========================================================================================\n\tFile Name: customizer.scss\n\tDescription: CSS used for demo purpose only. Remove this css from your project.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy React admin Template\n\tVersion: 1.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n  ==========================================================================================*/\n\n.customizer {\n  width: 400px;\n  right: -400px;\n  padding: 0;\n  background-color: #fff;\n  z-index: 1051;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  backface-visibility: hidden;\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),\n    0 5px 15px 0 rgba(0, 0, 0, 0.08);\n\n  .open-icon {\n    animation: Spin 2s infinite linear;\n    position: relative;\n    top: -2px;\n  }\n\n  &.open {\n    right: 0;\n  }\n\n  // customizer content height\n  .customizer-content {\n    position: relative;\n    height: calc(100% - 7rem);\n\n    .bg-default {\n      background-color: #fff;\n    }\n  }\n\n  //customizer close button\n  .customizer-close {\n    position: absolute;\n    right: 30px;\n    top: 20px;\n    padding: 7px;\n    width: auto;\n    z-index: 10;\n    color: #626262;\n    i {\n      font-size: 1.71rem;\n    }\n  }\n\n  // customizer toggle icon\n  .customizer-toggle {\n    background: #7367f0;\n    color: #fff;\n    display: block;\n    box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.1);\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n    position: absolute;\n    top: 50%;\n    width: 38px;\n    height: 38px;\n    left: -39px;\n    text-align: center;\n    line-height: 40px;\n    cursor: pointer;\n  }\n\n  // theme color box styles\n  .color-box {\n    height: 35px;\n    width: 35px;\n    margin: 0.5rem;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    &.selected {\n      box-shadow: 0 0 0 3px rgba(52, 144, 220, 0.5);\n      transition: all 0.2s ease-in-out;\n    }\n    &.disabled {\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n  }\n}\n\nbody.dark-layout {\n  .hide-scroll-top-switch,\n  .collapse-sidebar {\n    .custom-switch {\n      .custom-control-label {\n        &:before {\n          background-color: #10163a;\n        }\n      }\n    }\n  }\n}\n\n.buy-now {\n  position: fixed;\n  bottom: 5%;\n  right: 79px;\n  z-index: 1031;\n  .btn {\n    box-shadow: 0 1px 20px 1px #EA5455 !important;\n    &:hover {\n      box-shadow: none !important;\n    }\n  }\n}\n\n// Spining Animation\n\n@keyframes Spin {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
